import * as React from "react";
import { useHubx } from "../../HubX";
import { makeStyles, Switch, Theme } from "@material-ui/core";
import useConstructor from "../../core/hooks/useConstructor";
import { LocalCache } from "../../helpers/cache";
import { EVENT_DARK_MODE } from "../../Events";
import Brightness2Icon from "@material-ui/icons/Brightness2";
import WbSunnyIcon from "@material-ui/icons/WbSunny";

function DarkModeSwitch() {
  const [isDarkMode, setDarkMode] = React.useState<boolean>(false);
  const lcache = new LocalCache();
  const hub = useHubx();

  const useStyles = makeStyles((theme: Theme) => ({
    switchBase: {
      "&$checked": {
        "transform": "translateX(25px)",
        "& + $track": {
          backgroundColor: "#cfd7dc",
        },
      },
      "&$checked:hover": {
        backgroundColor: "#89d32930",
      },
      "&$focusVisible $thumb": {
        color: "#cfd7dc",
        border: "6px solid #fff",
      },
    },
  }));

  const classes = useStyles();

  useConstructor(async () => {
    const prefersDarkMode = lcache.get<boolean>("prefersDarkMode") || false;
    hub.notify(EVENT_DARK_MODE, prefersDarkMode);
    setDarkMode(prefersDarkMode);
  });

  const handleSwitch = () => {
    const state = !isDarkMode;
    setDarkMode(state);
    lcache.set("prefersDarkMode", state);
    hub.notify(EVENT_DARK_MODE, state);
  };

  return (
    <div>
      <Switch
        checked={isDarkMode}
        onChange={handleSwitch}
        icon={<WbSunnyIcon />}
        checkedIcon={<Brightness2Icon />}
        className={classes.switchBase}
      />
    </div>
  );
}

export default DarkModeSwitch;
